export default __webpack_public_path__ + "static/media/LDC.0e35a85e.svg";